import { useGlobalContext } from "../../../../../Context/Context";
import { useState } from "react";
import Button from "../../../../Custom/Button/Button";
import visibleImg from "../../../../../picture/Visible.png";
import sortImg from "../../../../../picture/Sort.png";
import redniBrojeviImg from "../../../../../picture/redniBrojevi.png";
import editImg from "../../../../../picture/edit.png";

const styles = {
  cell: {
    padding: "5px",
    textAlign: "center"
  },
  smallCell: {
    width: "40px",
    textAlign: "center"
  },
  icon: {
    width: "30px",
    height: "30px"
  }
};

function TabelaSredstva({ sredstva, setSredstva, setEditData, setPreviewId }) {
  const [isCheckedRedniBrojevi, setIsCheckedRedniBrojevi] = useState(false);
  const [isCheckedSort, setIsCheckedSort] = useState(false);

  const [checkedRows, setCheckedRows] = useState([]);
  const [isCheckedAll, setIsCheckedAll] = useState(false);

  const { dictionary } = useGlobalContext();

  const handleCheckRedniBrojevi = () => {
    setIsCheckedRedniBrojevi((prev) => !prev);
  };
  const handleCheckSort = () => {
    setIsCheckedSort((prev) => !prev);
    setSredstva(sredstva.reverse());
  };

  const handleCheckRow = (id) => {
    if (checkedRows.includes(id)) {
      setCheckedRows(checkedRows.filter((r) => r !== id));
    } else {
      setCheckedRows([...checkedRows, id]);
    }
  };
  const handleCheckAll = () => {
    if (isCheckedAll) {
      setCheckedRows([]);
    } else {
      setCheckedRows(sredstva.map((s) => s.id));
    }
    setIsCheckedAll((prev) => !prev);
  };

  const handlePreview = (id) => {
    setPreviewId(id);
  };

  return (
    <div style={{ flex: 1, overflowY: "auto" }}>
      <table style={{ width: "100%" }}>
        <tr>
          <th style={styles.smallCell}>
            <input
              type="checkbox"
              checked={isCheckedAll}
              onChange={handleCheckAll}
              style={{ width: "30px" }}
            />
          </th>
          <th style={{ width: "80px" }}>
            <div style={{ display: "flex" }}>
              <div onClick={handleCheckSort}>
                <Button active={isCheckedSort}>
                  <img
                    src={sortImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
              <div onClick={handleCheckRedniBrojevi}>
                <Button active={isCheckedRedniBrojevi}>
                  <img
                    src={redniBrojeviImg}
                    style={{ width: "40px", height: "30px" }}
                  />
                </Button>
              </div>
            </div>
          </th>
          <th style={styles.cell}>{dictionary["vrsta"]}</th>
          <th style={styles.cell}>{dictionary["tip"]}</th>
          <th style={styles.cell}>{dictionary["regOzn"]}</th>
          <th style={styles.cell}>{dictionary["istice"]}</th>
          <th style={styles.cell}>{dictionary["vozac"]}</th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
          <th style={styles.smallCell}></th>
        </tr>
        {sredstva.map((sredstvo, index) => (
          <tr key={sredstvo.id}>
            <td style={styles.cell}>
              <input
                type="checkbox"
                checked={checkedRows.includes(sredstvo.id)}
                onChange={() => handleCheckRow(sredstvo.id)}
                style={{ width: "30px" }}
              />
            </td>
            <td
              style={{ padding: "5px" }}
            >{`${isCheckedRedniBrojevi ? sredstvo.redniBroj : index + 1}.`}</td>
            <td style={styles.cell}>{sredstvo.vrsta.name}</td>
            <td style={styles.cell}>{sredstvo.tip}</td>
            <td style={styles.cell}>{sredstvo.regOznaka}</td>
            <td style={styles.cell}>{sredstvo.istice}</td>
            <td style={styles.cell}>{sredstvo.vozac.name}</td>
            <td
              onClick={() => setEditData(sredstvo)}
              style={{ ...styles.smallCell, cursor: "pointer" }}
            >
              <img src={editImg} style={{ width: "30px" }} />
            </td>
            <td style={styles.smallCell}>
              <div
                style={{
                  ...styles.icon,
                  backgroundColor: sredstvo.status,
                  margin: "auto"
                }}
              ></div>
            </td>
            <td
              onClick={() => handlePreview(sredstvo.id)}
              style={{ ...styles.smallCell, cursor: "pointer" }}
            >
              <img src={visibleImg} style={styles.smallCell} />
            </td>
          </tr>
        ))}
      </table>
    </div>
  );
}

export default TabelaSredstva;
